import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div ref={ref} className="relative w-full max-w-md">
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between rounded-md border border-stone-200 bg-white px-4 py-3 text-sm text-stone-700 hover:border-emerald-300 cursor-pointer"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="flex items-center gap-2">
          <i className="ri-apps-2-line text-emerald-600 w-4 h-4 flex items-center justify-center" />
          {t('home.catPlaceholder')}
        </span>
        <i className={`ri-arrow-down-s-line text-lg text-stone-500 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="absolute left-0 right-0 mt-2 max-h-96 overflow-y-auto rounded-lg border border-stone-200 bg-white py-1 z-40 shadow-md">
          {categories.map((c) => (
            <a
              key={c.id}
              href={c.link}
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-3 px-4 py-2.5 text-sm text-stone-700 hover:bg-emerald-50 cursor-pointer whitespace-nowrap"
              onClick={() => setOpen(false)}
            >
              <img
                src={c.image}
                alt={t(c.nameKey)}
                className="w-8 h-8 rounded-md object-cover shrink-0"
                loading="lazy"
              />
              <span>{t(c.nameKey)}</span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}